<rt-heading margin-left-medium margin-top-medium>
  {{ 'tlc.dynamic_form.define.answers' | translate }}
</rt-heading>

@if (defineForm().controls.options; as options) {
  <div class="choice-items" [class.manyItems]="options.length > 1">
    <div (cdkDropListDropped)="onReorder($event)" cdkDropList class="items-container">
      @for (option of options.controls; track $index) {
        <div cdkDrag class="choice-item">
          @if (options.length > 1) {
            <div class="item-grabber">
              <rt-icon name="drag-vertical" cdkDragHandle />
            </div>
          }
          <div
            [class.active]="activeInputIndex() === $index"
            [class.error]="option.invalid && option.dirty"
            class="input-wrap"
          >
            <div class="form-group-name">
              <rt-input
                variant="rounded"
                #optionElementRef
                [maxLength]="255"
                [formControl]="option.controls.value"
                (keyup.enter)="onEnter($index)"
                (focus)="setActiveInput($index)"
                (blur)="setActiveInput(null)"
              />
              @if (options.length > 1) {
                <rt-icon-button variant="plain" iconName="close" (click)="removeOption(option)" />
              }
            </div>
            <!--            @if (option.controls.title.errors?.required && option.controls.title.touched) {-->
            <!--              <span text-red padding-top-small-xx>{{-->
            <!--                'app.settings.referrals.questions.required_answer_error' | translate-->
            <!--              }}</span>-->
            <!--            }-->
          </div>
        </div>
      }
    </div>
    <rt-group class="choice-add">
      <rt-button (click)="addOption()" variant="outline">
        <rt-icon name="add" />
        <span>{{ 'tlc.dynamic_form.define.add_answer' | translate }}</span>
      </rt-button>
    </rt-group>
  </div>
}
